import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { fromPrice, hasRange } from '../../utils/products';
import type { Product } from '../../types/product';
import { Stars } from './Stars';
const badgeLabel: Record<string, string> = {
  bestseller: 'Bestseller',
  nieuw: 'Nieuw',
  cadeau: 'Cadeau'
};
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    add
  } = useCart();
  const first = product.variants[0];
  const badge = product.badges[0];
  return <article className="group relative flex h-full flex-col" data-id="element-334" data-mp="272ravkcxvljt">
      <div className="relative overflow-hidden rounded-2xl bg-surface" data-id="element-335" data-mp="223erj9la0wlz">
        <Link to={`/product/${product.slug}`} aria-label={product.name} data-id="element-336" data-mp="2247ndfip61pc">
          <img src={product.image} alt="" className="aspect-square w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-337" data-mp="cp9lrswvygmo" />
        </Link>
        {badge && <span className="absolute left-3 top-3 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-ink" data-id="element-338" data-mp="3gq5ihg9g0d68">
            {badgeLabel[badge]}
          </span>}
        <button type="button" onClick={() => add(product.slug, first.id)} className="absolute bottom-3 right-3 grid h-10 w-10 place-items-center rounded-full bg-ink text-canvas transition-[background-color,transform] duration-150 hover:bg-clay active:scale-95" aria-label={`${product.name} (${first.label}) toevoegen aan winkelwagen`} data-id="element-339" data-mp="3qole9wjf0am2">
          <PlusIcon className="h-4 w-4" data-id="element-340" data-mp="dckzmb2xirxm" />
        </button>
      </div>
      <div className="flex flex-1 flex-col pt-4" data-id="element-341" data-mp="iaw9glt852fu">
        <Stars rating={product.rating} reviews={product.reviews} data-id="element-342" data-mp="i9l4iio1lon5" />
        <h3 className="mt-2 text-base font-semibold tracking-tight text-ink" data-id="element-343" data-mp="2f3oc75wdqgkt">
          <Link to={`/product/${product.slug}`} className="hover:underline hover:underline-offset-4" data-id="element-344" data-mp="2k17mxvtvcb80">
            {product.name}
          </Link>
        </h3>
        <p className="mt-0.5 text-sm text-muted" data-id="element-345" data-mp="2c34d1tntscy1">{product.subtitle}</p>
        <p className="mt-auto pt-3 text-base font-semibold text-ink" data-id="element-346" data-mp="2738iel10pxv5">
          {hasRange(product) && <span className="mr-1 text-sm font-normal text-muted" data-id="element-347" data-mp="2m094a7wj2ylp">vanaf</span>}
          {formatPrice(fromPrice(product))}
          {first.compareAt && <span className="ml-2 text-sm font-normal text-muted line-through" data-id="element-348" data-mp="2uzw2kktynoaj">{formatPrice(first.compareAt)}</span>}
        </p>
      </div>
    </article>;
}